import React, { useState } from 'react'
import { View, StyleSheet, ScrollView, TouchableOpacity, Linking } from 'react-native'

import {
  Text,
  Label,
  Description,
  Space,
  ProductListItem,
  Title
} from '@sart/components'
import client, { useClient } from '@sart/client'
import { adaptive, colors, typography } from '@sart/styles'
import { ShoppingBag } from '@sart/icons'
import { useContent } from '@sart/content'


export default function Addons(props) {
  const { navigation, route } = props
	const content = useContent()
  const addons = route.params?.ADTAddons
//   const basketQuantities = navigation.getParam('basketQuantities')
  const title = route.params?.title
  const description = route.params?.description
  const [ loading, setLoading ] = useState(true)
  
  const {
      cache: {
          basket,
					language
        } = {}
    } = useClient()
    
  const basketQuantities = basket && basket.length > 0 ? calculateBasketQuantities() : 0

  async function checkoutProduct(product) {
    if (!loading){
      if(product.href !== undefined) {
        Linking.openURL(product.href)
      } else {
        setLoading(true)
        try {
          let updatedBasket = await client.addToCacheBasket(product)
          client.setCache({basket: updatedBasket})
          // setHasBasket(true)
          navigation.navigate('Checkout')
        } catch (error) {
          //do nothing for now
        }

        setLoading(false)
      }
    }
  }
  
  var disabledProduct = []
  if (basket) {
    disabledProduct = basket.map(product => {
      return product.productId;
    })
  }

  function calculateBasketQuantities(){
    let quantity = 0

    if (basket && basket.length > 0){
      for(var i = 0; i < basket.length; i++) {
        if (basket[i].quantity){
          quantity += basket[i].quantity
        }
      }
    }

    return quantity
  }
  return (
    <ScrollView style={styles.container}>
        
    { (basket && basket.serviceItems.length > 0) &&
        <TouchableOpacity style={styles.checkout} onPress={() => navigation.navigate('Checkout')}>
          <ShoppingBag onPress={() => navigation.navigate('Checkout')}/>
          <View style={styles.circle}>
            <Text style={styles.text}>
              {basketQuantities}
            </Text>
          </View>
        </TouchableOpacity>
      }

      {(basket===undefined || basket.length <= 0) &&
        <Space height={12} />
      }

      <Title style={styles.title}>{title}</Title>
      
      {(basket===undefined || basket.length <= 0) &&
        <Space height={4} />
      }    
      
      <Space height={18} />
      {addons.map(addOn => (
        <React.Fragment key={addOn.productId}>
            <ProductListItem
                disabled={disabledProduct.includes(addOn.productId)}
                product={addOn}
                onPress={() => checkoutProduct(addOn)}
                priceStyle={styles.price}
                placeholderStyle={styles.productStyle}
                bodyStyle={styles.body}
                imageColor={colors.white}
								language={language}
								injectedContent={content}
            />
            <Space height={12} />
        </React.Fragment>
    ))}
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.darkCharcoal,
    ...adaptive.wrapperPadding
  },
  checkout: {
    position: 'relative',
    top: '7%',
    flexDirection:'row',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    zIndex: 1
  },
  checkoutText: {
    fontSize:18,
    color:colors.srGreen
  },
  description: {
    textAlign: 'center',
    // paddingTop: 10,
    // marginTop: 7,
    ...typography.lightbold,
    marginBottom: 14,
    color: colors.black
  },
  price: {
    color: colors.black
  },
  circle: {
    // position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: '4%',
    right:'40%',
    // left: 16,
    backgroundColor: colors.srTextInput,
    borderRadius: 8
  },
  text: {
    fontSize: 12,
    lineHeight: 12,
    fontWeight: '700',
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 3,
    paddingBottom: 2,
    textAlign: 'center',
    color: colors.srGreen
  },
  title: {
      ...typography.demi,
      fontSize: 16,
      color: colors.srTextInput,
  },
  productStyle: {
    backgroundColor: colors.srGreen
  },
  body: {
    flex: 1,
    paddingHorizontal: 12,
    paddingVertical: 6,
    justifyContent: 'center'
  }
})
